import React, { useMemo } from 'react';
import { StyledList } from './MuiSidebarMenu.styles';
import { useSidebarMenu } from '../../hooks/useSidebarMenu';
import { useIsCollapsed } from '../../hooks/useCollapsedMenu';
import MenuItem from './MenuItem';
import { MenuProps } from '../../types';

const MuiSidebarMenu = ({ menuItems, onItemClick, currentPath, isMenuOpen }: MenuProps) => {
    const { expandedItems, handleToggleExpand } = useSidebarMenu(menuItems, currentPath, isMenuOpen);
    // Un seul MutationObserver pour tout le menu, partagé via prop
    const isCollapsed = useIsCollapsed();

    const memoizedMenuItems = useMemo(() => 
        menuItems.map((item, index) => (
            <MenuItem
                key={item.id || item.label || index}
                item={item}
                onItemClick={onItemClick}
                currentPath={currentPath}
                expandedItems={expandedItems}
                onToggleExpand={handleToggleExpand}
                isCollapsed={isCollapsed}
            />
        )), 
        [menuItems, onItemClick, currentPath, expandedItems, handleToggleExpand, isCollapsed]
    );

    return <StyledList>{memoizedMenuItems}</StyledList>;
};

export default MuiSidebarMenu;
